module.exports = __webpack_public_path__ + "img/dog.7b881194.jpg";